/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Models_TitleInputs */

const en_directory_models_title = /** @type {(inputs: Directory_Models_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare AI models`)
};

const zh_directory_models_title = /** @type {(inputs: Directory_Models_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对比 AI 模型`)
};

/**
* | output |
* | --- |
* | "Compare AI models" |
*
* @param {Directory_Models_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_models_title = /** @type {((inputs?: Directory_Models_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Models_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_models_title(inputs)
	return zh_directory_models_title(inputs)
});
export { directory_models_title as "directory.models.title" }